export default {
    name: 'Example',
    import: function () { return import('./index'); },
};
